import React from "react";

import { IoLogoWhatsapp } from "react-icons/io";
import { BsFacebook } from "react-icons/bs";
import { AiFillTwitterCircle } from "react-icons/ai";
import { BsQrCode } from "react-icons/bs";
const ReceiveBtc = () => {
  return (
    <div className=" h-screen flex items-center justify-center">
      <div className=" text-center md:flex-col items-center justify-center shadow-md p-14">
        <h1 className=" text-3xl tracking-widest  "> Receive DIO</h1>
        <p className=" text-gray-700 pt-4  ">
          {" "}
          Only receive DIO to this address sending any other digital asset ,
          will result in permanent loss.
        </p>

        <center className="pt-4">
          <BsQrCode size={150} color="gray" />
        </center>

        <div className="md:flex gap-2 items-center justify-center md:pr-12 py-6 ">
          <h1 className="text-gray-700 ">DIO Wallet Address</h1>
          <center>
            <input
              type="text"
              name="price"
              id="price"
              class="block w-sm rounded-lg border-0 py-1.5 pl-8 pr-8  text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-400 sm:text-sm sm:leading-6 "
              placeholder="0.00 BTC"
            />
          </center>
          <button className=" border rounded-full h-10 w-24 bg-slate-600  text-sm  text-white ">
            {" "}
            Copy
          </button>
        </div>
        <div className="md:flex gap-10 items-center justify-center ">
          <div>
            <h1 className="text-gray-700 ">Share via social Apps</h1>
          </div>
          <div className="  flex items-center justify-center gap-4">
            <IoLogoWhatsapp size={24} color="green" />
            <BsFacebook size={20} color="blue" />
            <AiFillTwitterCircle size={24} color="skyblue" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiveBtc;
